export const DEFAULT_DATE_TIME_FORMAT = 'MMM d, yyyy hh:mm aaaa';
export const DEFAULT_DATE_FORMAT = 'MMM d, yyyy';
export const DEFAULT_TIME_FORMAT = 'hh:mm aaaa';
